import { render, staticRenderFns } from "./turn-book.vue?vue&type=template&id=3462146e&scoped=true"
import script from "./turn-book.vue?vue&type=script&lang=js"
export * from "./turn-book.vue?vue&type=script&lang=js"
import style0 from "./turn-book.vue?vue&type=style&index=0&id=3462146e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3462146e",
  null
  
)

export default component.exports